import styled from 'styled-components'
import a1 from './image/arrows/arrow-01.png'
import a2 from './image/arrows/arrow-02.png'
import a3 from './image/arrows/arrow-03.png'
import a4 from './image/arrows/arrow-04.png'
import a5 from './image/arrows/arrow-05.png'
import a6 from './image/arrows/arrow-06.png'
import a7 from './image/arrows/arrow-07.png'
import a8 from './image/arrows/arrow-08.png'
import a9 from './image/arrows/arrow-09.png'
import a10 from './image/arrows/arrow-10.png'
import a11 from './image/arrows/arrow-11.png'
import a11b from './image/arrows/arrow-11b.png'
import a12 from './image/arrows/arrow-12.png'
import a13 from './image/arrows/arrow-13.png'
import a14 from './image/arrows/arrow-14.png'
import a15 from './image/arrows/arrow-15.png'
import a16 from './image/arrows/arrow-16.png'
import a17 from './image/arrows/arrow-17.png'
import a18 from './image/arrows/arrow-18.png'
import a19 from './image/arrows/arrow-19.png'
import a20 from './image/arrows/arrow-20.png'
import a21 from './image/arrows/arrow-21.png'
import a22 from './image/arrows/arrow-22.png'
import a23 from './image/arrows/arrow-23.png'
import a24 from './image/arrows/arrow-24.png'
import a25 from './image/arrows/arrow-25.png'
import a26 from './image/arrows/arrow-26.png'
import a27 from './image/arrows/arrow-27.png'
import a28 from './image/arrows/arrow-28.png'
import a29 from './image/arrows/arrow-29.png'
import a30 from './image/arrows/arrow-30.png'
import a31 from './image/arrows/arrow-31.png'
import a32 from './image/arrows/arrow-32.png'
import a33 from './image/arrows/arrow-33.png'
import a34 from './image/arrows/arrow-34.png'
import watermark from './image/watermark.png'
import background from './image/defaultNoSlideBG.jpg'

export const LtPoweredBy = styled.div`
    position: absolute;
    top: 0; left: 0;
    background-color: #e6b984;
    padding: 8px 10px;
    z-index: 99;
`
export const Watermark = styled.div`
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-image: url(${watermark});
    background-repeat: repeat;
    z-index: 99;
`
export const LightSlider = styled.div`
    width: 100%;
    height: 100%;
    background-size: cover;
`

export const LightSliderContainer = styled.div`
    & *{
        box-sizing: border-box;
    }
    

    &:hover{
        .lSAction{
            transition: .3s;
            opacity: 1;
        }
    }

    .svg-arrow {
        fill: ${props => props.arrowsFillColor};
        cursor: pointer;
        z-index: 99999999999;
        position: fixed;
        transition: .1s;
        &:hover {
            fill: ${props => props.arrowsFillHoverColor};
        }
    
        path {
            transition: .1s;
            stroke: ${props => props.arrowsStrokeColor};
        }
    
        &:hover path {
            stroke: ${props => props.arrowsStrokeHoverColor};
        }
    }
    
    .lSAction{
        opacity: ${props => props.hasNavigationOnHover ? 0 : 1};
        transition: .3s;
    }

    .lSAction>a{
        transform:scale(${props => props.arrowScale});
        background: ${props => props.customArrows ? 'none!important' : ''};
        opacity: ${props => props.customArrows ? '1!important' : ''};
    }

    .lSSlideOuter .lSPager {
        display: flex;
        justify-content: center;
        /* mobile */
        ${props => props.deviceType === 'mobile' ? 
        `justify-content: space-around;
        width: ${props.slideLength * (props.dotsSize + 12)}px;
        height: ${props.slideLength * (props.dotsHeight + 12)}px;
        max-width: 100%;
        margin: 0 auto;`
         : ''}
        
    }

    .lSSlideOuter .lSPager.lSpg>li {
        padding: 0 ${props => Number.isInteger(props.dotsSpacing) ? props.dotsSpacing / 2 : 5}px;
    }

    .lSSlideOuter .lSPager.lSpg>li a{
        width: ${props => props.dotsSize}px;
        height: ${props => props.dotsHeight}px;
        border: ${props => props.dotsBorder};
        border-radius: ${props => props.dotsBorderRadius};
        background-color: ${props => props.dotsColor};
        &:hover{
            background-color: ${props => props.dotsColorHover};
        }
    }

    .lSSlideOuter .lSPager.lSpg>.active> a{
        width: ${props => props.dotsSize}px;
        height: ${props => props.dotsHeight}px;
        border: ${props => props.dotsBorder};
        border-radius: ${props => props.dotsBorderRadius};
        background-color: ${props => props.dotsColorActive};
        &:hover{
            background-color: ${props => props.dotsColorHover};
        }
    }
`



export const GetLightSliderContainer = props => {
    const LightSliderContainer = styled.div`
    & *{
        box-sizing: border-box;
    }
    .parallaxBackground{
        position: absolute;
        display: ${props.hasParallax && props.hasSlides ? 'block' : 'none'};
        background: url(${'https://media.wix.com/media/' + props.relativeUri});
        width: 100%;
        height:100%;
        background-size: ${props.deviceType === 'desktop' ? props.scale * 100 : props.mobileScale * 100}%;
        background-position: ${props.deviceType === 'desktop' ? props.offsetX : props.mobileOffsetX}px ${props.deviceType === 'desktop' ? props.offsetY : props.mobileOffsetY}px;
        background-repeat: no-repeat;
        transform-origin: center center;
    }

    &:hover{
        .lSAction{
            transition: .3s;
            opacity: 1;
        }
    }
    
    .lSAction{
        opacity: ${props.hasNavigationOnHover ? 0 : 1};
        transition: .3s;
    }

    .lSAction>a{
        transform:scale(${props.arrowScale});
    }

    .lSSlideOuter .lSPager {
        display: flex;
        justify-content: center;
    }

    .lSSlideOuter .lSPager.lSpg>li {
        padding: 0 ${Number.isInteger(props.dotsSpacing) ? props.dotsSpacing / 2 : 5}px;
    }

    .lSSlideOuter .lSPager.lSpg>li a{
        width: ${props.dotsSize}px;
        height: ${props.dotsSize}px;
        border-radius: 50px;
        background-color: ${props.dotsColor};
        &:hover{
            background-color: ${props.dotsColorHover};
        }
    }

    .lSSlideOuter .lSPager.lSpg>.active> a{
        width: ${props.dotsSize}px;
        height: ${props.dotsSize}px;
        border-radius: 50px;
        background-color: ${props.dotsColorActive};
        &:hover{
            background-color: ${props.dotsColorHover};
        }
    }
            
               
`

    return (
        <LightSliderContainer >
            {props.children}
        </LightSliderContainer>
    )

}

export const AttentionContainer = styled.div`
	position: fixed;
	bottom: 0;
	right: 0;
	text-align: center;
	background-color: #fff;
	z-index: 9999;
	border-radius: 20px 40px 0px 20px;
	padding: 9px 28px 9px 16px;
	font-weight: bold;
	font-size: 11px;
	color: #666666;
`


// height:${props => props.height}px;
// background-color: ${props => props.hasSlides ? props.widgetBgColor : `#fff`};
// background-image: ${props => props.hasSlides ? '' : `url(${background})`};
// background-size:${window.innerWidth / window.innerHeight > 2.65 ? 'cover' : 'contain'};
export const WidgetContainerStyle = styled.div`
    background-repeat: no-repeat;
    background-position: center;
    
#a1{
    background-image: url(${a1})!important;
}
#a2{
    background-image: url(${a2})!important;
}
#a3{
    background-image: url(${a3})!important;
}
#a4{
    background-image: url(${a4})!important;
}
#a5{
    background-image: url(${a5})!important;
}
#a6{
    background-image: url(${a6})!important;
}
#a7{
    background-image: url(${a7})!important;
}
#a8{
    background-image: url(${a8})!important;
}
#a9{
    background-image: url(${a10})!important;
}
#a10{
    background-image: url(${a11})!important;
}
#a11{
    background-image: url(${a11b})!important;
}
#a12{
    background-image: url(${a12})!important;
}
#a13{
    background-image: url(${a13})!important;
}
#a14{
    background-image: url(${a14})!important;
}
#a15{
    background-image: url(${a15})!important;
}
#a16{
    background-image: url(${a16})!important;
}
#a17{
    background-image: url(${a17})!important;
}
#a18{
    background-image: url(${a18})!important;
}
#a19{
    background-image: url(${a19})!important;
}
#a20{
    background-image: url(${a20})!important;
}
#a21{
    background-image: url(${a21})!important;
}
#a22{
    background-image: url(${a22})!important;
}
#a23{
    background-image: url(${a23})!important;
}
#a24{
    background-image: url(${a24})!important;
}
#a25{
    background-image: url(${a25})!important;
}
#a26{
    background-image: url(${a26})!important;
}
#a27{
    background-image: url(${a27})!important;
}
#a28{
    background-image: url(${a28})!important;
}
#a29{
    background-image: url(${a29})!important;
}
#a30{
    background-image: url(${a30})!important;
}
#a31{
    background-image: url(${a31})!important;
}
#a32{
    background-image: url(${a32})!important;
}
#a33{
    background-image: url(${a33})!important;
}
#a34{
    background-image: url(${a34})!important;
}
/* #a9{
    background-image: url(${a9})!important;
}
#a10{
    background-image: url(${a10})!important;
}
#a11{
    background-image: url(${a11})!important;
}
#a12{
    background-image: url(${a11b})!important;
}
#a13{
    background-image: url(${a12})!important;
}
#a14{
    background-image: url(${a13})!important;
}
#a15{
    background-image: url(${a14})!important;
}
#a16{
    background-image: url(${a15})!important;
}
#a17{
    background-image: url(${a16})!important;
}
#a18{
    background-image: url(${a17})!important;
}
#a19{
    background-image: url(${a18})!important;
}
#a20{
    background-image: url(${a19})!important;
}
#a21{
    background-image: url(${a20})!important;
}
#a22{
    background-image: url(${a21})!important;
}
#a23{
    background-image: url(${a22})!important;
}
#a24{
    background-image: url(${a23})!important;
}
#a25{
    background-image: url(${a24})!important;
}
#a26{
    background-image: url(${a25})!important;
}
#a27{
    background-image: url(${a26})!important;
}
#a28{
    background-image: url(${a27})!important;
}
#a29{
    background-image: url(${a28})!important;
}
#a30{
    background-image: url(${a29})!important;
}
#a31{
    background-image: url(${a30})!important;
}
#a32{
    background-image: url(${a31})!important;
}
#a33{
    background-image: url(${a32})!important;
}
#a34{
    background-image: url(${a33})!important;
}
#a35{
    background-image: url(${a34})!important;
} */
`
